// API 配置
const isDevelopment = process.env.NODE_ENV === 'development' || process.env.REACT_APP_ENV === 'development';
const API_BASE_URL = isDevelopment 
    ? 'http://127.0.0.1:8668'
    : 'https://maruwhite-backend-96717484204.asia-east1.run.app';

// 在開發時輸出環境變數，方便調試
if (isDevelopment) {
    console.log('Current NODE_ENV:', process.env.NODE_ENV);
    console.log('Current REACT_APP_ENV:', process.env.REACT_APP_ENV);
}

export const getApiUrl = (endpoint) => {
    return `${API_BASE_URL}${endpoint}`;
};

const apiConfig = {
    API_BASE_URL,
    getApiUrl,
    isDevelopment
};

export default apiConfig; 